import React from "react";

const DEFAULT_SIZE = 64;

// Diamond lattice inspired by the Weave logo. Ghost tiles sit around the
// edges, smaller and quieter. `wave` is the stagger index for the appear wave.
const TILES = [
  { x: -21, y: -12, wave: 0, ghost: true },
  { x: 21, y: -12, wave: 1, ghost: true },
  { x: -63, y: 0, wave: 0, ghost: true },
  { x: -42, y: 0, wave: 1 },
  { x: 0, y: 0, wave: 2 },
  { x: 42, y: 0, wave: 3, accent: true },
  { x: 63, y: 0, wave: 4, ghost: true },
  { x: -63, y: 12, wave: 1, ghost: true },
  { x: -21, y: 12, wave: 2 },
  { x: 21, y: 12, wave: 3 },
  { x: 63, y: 12, wave: 4, ghost: true },
  { x: -42, y: 24, wave: 3, ghost: true },
  { x: 0, y: 24, wave: 4, outline: true },
  { x: 42, y: 24, wave: 5, ghost: true },
  { x: -21, y: 36, wave: 5, ghost: true },
  { x: 21, y: 36, wave: 6, ghost: true },
];

const DIAMOND = "M-18 0L0 -10L18 0L0 10Z";
const CYCLE = 2.8;
const STEP = 0.14;

const WeaveLoader = ({ size = DEFAULT_SIZE, text = null, className = "" }) => {
  const parsedSize = Number(size);
  const iconSize = Number.isFinite(parsedSize) && parsedSize > 0 ? parsedSize : DEFAULT_SIZE;
  const width = Math.round(iconSize * 2.6);

  return (
    <>
      <style>{`
        @keyframes weaveFadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes weaveTile {
          0%, 12% { opacity: 0; transform: scale(0.4); }
          28%, 48% { opacity: var(--tile-peak); transform: scale(1); }
          64%, 100% { opacity: 0; transform: scale(0.4); }
        }
      `}</style>
      <span
        role="status"
        aria-live="polite"
        aria-label={text || "Loading"}
        className={`flex flex-col items-center justify-center text-center ${className}`.trim()}
        style={{
          color: "var(--theme-text)",
          animation: "weaveFadeIn 0.5s ease-out 0.5s both",
        }}
      >
        <svg
          width={width}
          height={iconSize}
          viewBox="-80 -28 160 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          overflow="visible"
        >
          {TILES.map((tile) => {
            const key = `${tile.x},${tile.y}`;
            const sizeScale = tile.ghost ? 0.52 : 1;
            const peak = tile.ghost ? 0.05 : tile.outline ? 0.5 : 0.85;
            const fill = tile.accent ? "#38BDF8" : "currentColor";

            return (
              <g key={key} transform={`translate(${tile.x} ${tile.y})`}>
                <g
                  style={{
                    animation: `weaveTile ${CYCLE}s ease-in-out ${tile.wave * STEP}s infinite`,
                    transformOrigin: "0px 0px",
                    ["--tile-peak"]: peak,
                  }}
                >
                  {tile.outline ? (
                    <path
                      d={DIAMOND}
                      transform={`scale(${sizeScale})`}
                      stroke="currentColor"
                      strokeWidth="1.4"
                      fill="none"
                    />
                  ) : (
                    <path
                      d={DIAMOND}
                      transform={`scale(${sizeScale})`}
                      fill={fill}
                    />
                  )}
                </g>
              </g>
            );
          })}
        </svg>

        {text ? (
          <span className="mt-3 text-sm text-theme-text opacity-70">
            {text}
          </span>
        ) : null}
      </span>
    </>
  );
};

export default WeaveLoader;
